
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whistleblowing",
      function () {
        return require("private-next-pages/whistleblowing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whistleblowing"])
      });
    }
  